<template lang="">
    <div class="shadow">
        <div class="card-header bg-transparent">
            <div>
                <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                <h3 class="mb-0 text-center">
                    {{ $t('message.add') }} Médicament
                </h3>
            </div>
        </div>
        <div>
            <button class="btn btn-primary" v-b-modal.modal-center>Nouveau médicament</button>
            <b-modal id="modal-center" hide-footer centered title="Nouveau Médicament">
                <div class="my-4">
                    Formulaire ajout médicament
                </div>
            </b-modal>
        </div>
        <div class="medicament-table bg-white mt-2 rounded">
            <table class="table">
                <thead>
                    <tr>
                        <th>Dénomination</th>
                        <th>Prix</th>
                        <th>Heure prescription</th>
                        <th>Description traitement</th>
                        <th>Durée traitement</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(medicament, index) in medicaments" :key="index.medicament">
                        <td>{{ medicament.denomination }}</td>
                        <td>{{ medicament.prix }}</td>
                        <td>{{ medicament.horaire }}</td>
                        <td>{{ medicament.descriptifHoraire }}</td>
                        <td>{{ medicament.dureeTraitement }}</td>
                        <td>{{ medicament.descriptifTraitement }}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
export default {
    name: "medicament",
    computed: {
            ...mapGetters(["medicaments", "errors", 'hasAdminRole',
                'hasMedecinControleRole', 'hasPraticienRole','hasAssistante']),
        },
    methods: {
        getMedicaments() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };
            
            this.$store.dispatch('getMedicaments', { args : args });
        },
    },
    mounted() {
        this.getMedicaments();
    }
}
</script>
<style lang=""></style>